/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Form } from '../../models/form';

export interface FindOneForm$Params {
  formId: string;
}

export function findOneForm(
  http: HttpClient,
  rootUrl: string,
  params: FindOneForm$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Form>> {
  const rb = new RequestBuilder(rootUrl, findOneForm.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Form>;
    })
  );
}

findOneForm.PATH = '/forms/{formId}';
